export const SLIDES_LOADER_VARIANTS_COUNT = 4;
export const SLIDES_LOADER_CHANGE_PERIOD_MS = 2000;
export const SLIDES_LOADER_START_INDEX = 0;
export const INVESTIGATE_CH_TEXT = 'Изучаем вашу кредитную историю';
export const SELECTION_OFFERS_TEXT = 'Подбираем лучшие кредитные предложения под ваши параметры';
export const LOOKING_BEST_BANKS_TEXT = 'Ищем банки с высокой вероятностью одобрения';
export const LOAD_ANKETA = 'Загружаем вашу анкету';
